window.StockCubeCore = window.StockCubeCore || {};

window.StockCubeCore.schemaBase = {
    dataSource: {
        type: 'string',
        default: 'top-dollar-vol-sec',
        oneOf: [
            'top-gainers', 'top-losers', 'top-gainers-sec', 'top-losers-sec',
            'top-vol-sec', 'top-vol', 'top-dollar-vol', 'top-dollar-vol-sec',
            'mmap', 'sip', 'sip-sec', 'dividend', 'dividend-sec', 'watchlist-reports'
        ]
    },
    banner:          { type: 'string',  default: 'Top Total $ Volume by Sector' },
    sectorIds:       { type: 'array',   default: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
    selector:        { type: 'selector', default: null },
    topN:            { type: 'number',  default: 6 },
    interval:        { type: 'string',  default: '1d' },
    watchlistId:     { type: 'string',  default: null },
    timelineEntity:  { type: 'selector', default: null },
    injectedData:    { type: 'string',  default: '' },
    excludedTickers: { type: 'array',   default: [] },
};
